var map = {
	"./CanvasClear": 7202,
	"./CanvasClear.js": 7202,
	"./CanvasMove": 327,
	"./CanvasMove.js": 327,
	"./CommandAbstract": 238,
	"./CommandAbstract.js": 238,
	"./ComponentDelete": 5820,
	"./ComponentDelete.js": 5820,
	"./ComponentDrag": 6694,
	"./ComponentDrag.js": 6694,
	"./ComponentEnter": 1947,
	"./ComponentEnter.js": 1947,
	"./ComponentExit": 3888,
	"./ComponentExit.js": 3888,
	"./ComponentNext": 5883,
	"./ComponentNext.js": 5883,
	"./ComponentPrev": 7508,
	"./ComponentPrev.js": 7508,
	"./ComponentStyleClear": 8769,
	"./ComponentStyleClear.js": 8769,
	"./CopyComponent": 2213,
	"./CopyComponent.js": 2213,
	"./DeleteComponent": 5049,
	"./DeleteComponent.js": 5049,
	"./ExportTemplate": 3775,
	"./ExportTemplate.js": 3775,
	"./Fullscreen": 58,
	"./Fullscreen.js": 58,
	"./MoveComponent": 8658,
	"./MoveComponent.js": 8658,
	"./OpenAssets": 9617,
	"./OpenAssets.js": 9617,
	"./OpenBlocks": 5821,
	"./OpenBlocks.js": 5821,
	"./OpenLayers": 3452,
	"./OpenLayers.js": 3452,
	"./OpenStyleManager": 2840,
	"./OpenStyleManager.js": 2840,
	"./OpenTraitManager": 8644,
	"./OpenTraitManager.js": 8644,
	"./PasteComponent": 560,
	"./PasteComponent.js": 560,
	"./Preview": 4944,
	"./Preview.js": 4944,
	"./Resize": 7538,
	"./Resize.js": 7538,
	"./SelectComponent": 5130,
	"./SelectComponent.js": 5130,
	"./SelectPosition": 8463,
	"./SelectPosition.js": 8463,
	"./ShowOffset": 7994,
	"./ShowOffset.js": 7994,
	"./SwitchVisibility": 8352,
	"./SwitchVisibility.js": 8352
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2828;